import { useTranslation } from '@thoughtspot/i18n';
import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Icon } from '@thoughtspot/radiant-react/widgets/icon';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Toggle } from '@thoughtspot/radiant-react/widgets/toggle';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import { getClientId } from '@thoughtspot/system-config-service';
import React, { useEffect, useState } from 'react';
import { useGetMfaConfigLazyQuery, useUpdateMfaConifgMutation, } from '../../../../../../services/saml/saml-service';
import { useGetLocalIamV1Query, useSetLocalIamV1Mutation, } from '../../../../../../services/system/system-service';
import { getDefaultSamlHeaders, TranslationsKeys, } from '../../../../../authentication/constants';
import { getConfigRequestFromProviderConfig, getGroupName, getProviderConfigFromResponse, providerConfig as defaultProviderConfig, } from '../../../../../authentication/mfa/constants';
import styles from './local-auth-content.module.scss';
export const LocalAuthContent = ({ view = 'localAuth', onSettingChanged, }) => {
    const { t } = useTranslation();
    const [localAuthEnabled, setLocalAuthEnabled] = useState(false);
    const [providers, setProviders] = useState([
        ...defaultProviderConfig,
    ]);
    const { data: localAuthData, loading: localAuthLoading, } = useGetLocalIamV1Query();
    useEffect(() => {
        if (!localAuthLoading && localAuthData?.Data) {
            setLocalAuthEnabled(localAuthData.Data.status === true);
        }
    }, [localAuthData, localAuthLoading]);
    const [updateLocalAuth] = useSetLocalIamV1Mutation(() => {
    }, () => {
    }, { status: localAuthEnabled });
    const handleLocalAuthToggle = (checked) => {
        setLocalAuthEnabled(checked);
        updateLocalAuth({
            variables: { data: { status: checked } },
        });
        onSettingChanged?.();
    };
    const { getMfaConfigInfo, MfaConfigInfo, loading: mfaLoading, } = useGetMfaConfigLazyQuery();
    const { updateMfaConfig } = useUpdateMfaConifgMutation();
    useEffect(() => {
        getMfaConfigInfo({
            clientId: getClientId(),
            defaultHeaders: getDefaultSamlHeaders(),
            groupName: getGroupName(),
        });
    }, []);
    useEffect(() => {
        if (!mfaLoading && MfaConfigInfo) {
            setProviders([...getProviderConfigFromResponse(MfaConfigInfo)]);
        }
    }, [MfaConfigInfo, mfaLoading]);
    const handleProviderToggle = (index, checked) => {
        const updated = [...providers];
        updated[index] = { ...updated[index], enabled: checked };
        setProviders(updated);
        updateMfaConfig(getConfigRequestFromProviderConfig(updated));
        onSettingChanged?.();
    };
    const renderLocalAuth = () => (React.createElement(React.Fragment, null,
        React.createElement(Horizontal, { className: styles.localAuthRow, vAlignContent: "center" },
            React.createElement(Horizontal, { grow: true, vAlignContent: "center" },
                React.createElement(Typography, { variant: "body-normal", overrideTag: "span", className: styles.localAuthRowLabel, noMargin: true }, t(TranslationsKeys.SETTINGS_LOCAL_AUTH_ENABLE))),
            React.createElement(Toggle, { id: "local-auth-toggle", name: "local-auth-toggle", label: "", hideLabel: true, checked: localAuthEnabled, onChange: e => handleLocalAuthToggle(e.target.checked), className: styles.localAuthToggle, "data-testid": "local-auth-toggle" }))));
    const allMfaDisabled = providers.every(p => !p.enabled);
    const renderMfaSettings = () => (React.createElement(React.Fragment, null,
        allMfaDisabled && (React.createElement(Alert.Banner, { message: t(TranslationsKeys.SETTINGS_LOCAL_AUTH_MFA_DISABLED_WARNING), isVisible: true, type: BannerAlertType.WARNING, showCloseButton: false })),
        React.createElement(Typography, { variant: "h4", className: styles.localAuthSectionTitle, noMargin: true }, t(TranslationsKeys.SETTINGS_LOCAL_AUTH_METHODS)),
        providers.map((provider, index) => (React.createElement(Horizontal, { key: provider.id, className: styles.localAuthRow, vAlignContent: "center" },
            React.createElement(Horizontal, { grow: true, vAlignContent: "center", className: styles.providerInfo },
                React.createElement(Icon, { id: provider.icon, className: styles.providerIcon }),
                React.createElement(Vertical, { className: styles.providerText },
                    React.createElement(Typography, { variant: "body-normal", overrideTag: "span", className: styles.localAuthRowLabel, noMargin: true }, t(provider.name)),
                    React.createElement(Typography, { variant: "caption", overrideTag: "span", className: styles.providerDescription, noMargin: true }, t(provider.description)))),
            React.createElement(Toggle, { id: `provider-toggle-${provider.id}`, name: `provider-toggle-${provider.id}`, label: "", hideLabel: true, checked: provider.enabled, onChange: e => handleProviderToggle(index, e.target.checked), className: styles.localAuthToggle, "data-testid": `provider-toggle-${provider.id}` }))))));
    return (React.createElement(Vertical, { className: styles.localAuthContainer }, view === 'localAuth' ? renderLocalAuth() : renderMfaSettings()));
};
//# sourceMappingURL=local-auth-content.container.js.map